module.exports = __webpack_public_path__ + "media/img/flags@2x-9d5328fb.png";